import { UTCDate } from '@date-fns/utc';
import { addDays, isAfter, isValid, isWithinInterval } from 'date-fns';

const DATE_SOON_DAYS = 7;
const today = new UTCDate();

export type InvoiceStatusLabel = 'Paid' | 'Unknown' | 'Not due yet' | 'Due soon' | 'Overdue';

type GetInvoiceStatusLabelProps = {
  isPaid?: boolean;
  date?: string;
};

export const getInvoiceStatusLabel = ({ isPaid, date }: GetInvoiceStatusLabelProps): InvoiceStatusLabel => {
  if (isPaid) {
    return 'Paid';
  }

  if (!date || !isValid(new UTCDate(date))) {
    return 'Unknown';
  }

  const dateSoon = isWithinInterval(date, { start: today, end: addDays(today, DATE_SOON_DAYS) });
  const isDateInTheFuture = isAfter(date, today);

  if (!dateSoon && isDateInTheFuture) {
    return 'Not due yet';
  }

  if (dateSoon) {
    return 'Due soon';
  }

  return 'Overdue';
};
